export const formatTranslation = (
  translatedObj: any,
  interpolationOptions?: Record<string, string | number>
): string => {
  if (!translatedObj?.message) return "";

  return String(translatedObj.message).replace(
    /{{\s*([^{}]+?)\s*}}/g,
    (placeholder, name: string) => {
      const value = interpolationOptions?.[name];
      return value === undefined ? placeholder : String(value);
    }
  );
};
